module.exports = __webpack_public_path__ + "static/img/information-ad-image.cc03042.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/information-ad-image.jpg
// module id = 8GLL
// module chunks = 1